var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v("Fixácia")]), _c('button', {
    staticClass: "w-button saveformBtn",
    attrs: {
      "form": "maturity-choose",
      "type": "submit"
    }
  }, [_vm._v(" Nastaviť ")])]), _c('form', {
    attrs: {
      "id": "maturity-choose"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.saveApplicationData.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "najomne"
    }
  }, [_vm._v("Splatnosť v rokoch")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.splatnost_r,
      expression: "splatnost_r"
    }],
    staticClass: "text-input w-input required",
    attrs: {
      "type": "number",
      "step": "1",
      "min": "0",
      "max": "40",
      "maxlength": "256",
      "name": "najomne",
      "data-name": "najomne",
      "placeholder": "",
      "id": "najomne",
      "required": ""
    },
    domProps: {
      "value": _vm.splatnost_r
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.splatnost_r = $event.target.value;
      }
    }
  })])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }